var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rootContainer"},[_c('div',{staticClass:"topContainer"},[_c('layout-top')],1),_c('div',{staticClass:"mainContainer",style:({height:(_vm.windowHeight-_vm.topHeight)+'px'})},[_c('layout-main')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }